import { render, staticRenderFns } from "./AddressField.vue?vue&type=template&id=2f85fada&scoped=true&"
import script from "./AddressField.vue?vue&type=script&lang=js&"
export * from "./AddressField.vue?vue&type=script&lang=js&"
import style0 from "./AddressField.vue?vue&type=style&index=0&id=2f85fada&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f85fada",
  null
  
)

export default component.exports